import { MessageCircle } from "lucide-react";
import { trackEvent, waLink } from "@/lib/vgt";

export const FloatingWhatsApp = () => (
  <a
    data-testid="floating-whatsapp-button"
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Discuss your requirement on WhatsApp"
    onClick={() => trackEvent("whatsapp_click", { location: "floating_button" })}
    className="animate-pulse-ring fixed bottom-5 right-5 z-50 flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1EAE52] text-white rounded-full shadow-2xl px-4 py-3.5 transition-all duration-300 hover:scale-105"
  >
    <MessageCircle size={22} />
    <span className="hidden sm:block text-sm font-semibold leading-tight max-w-[190px]">
      Discuss Your Requirement on WhatsApp
    </span>
  </a>
);
